import React from 'react';

const Layout = ({children, pageCurrent}) => (

  <div className={`wrapper ${pageCurrent}`}>
    {children}
  </div>

)
export default Layout;